import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import type { InitialStateType } from './types';

export const statusInitialState: InitialStateType = {};

const statusSlice = createSlice({
  name: 'status',
  initialState: statusInitialState,
  reducers,
});

export const {
  setLoadingState,
  setErrorState,
  resetActionState,
  setSuccessState,
  setShowMessageState,
  setInitializedState,
} = statusSlice.actions;

export default statusSlice.reducer;
